var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRoundCheckmarkInverted = function SvgRoundCheckmarkInverted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M.24 14C.24 6.4 6.4.24 14 .24S27.76 6.4 27.76 14 21.6 27.76 14 27.76.24 21.6.24 14M20.16 8.492a.835.835 0 0 0-1.187-.009l-8.67 8.602-2.87-2.89-.015-.015a.835.835 0 0 0-1.171.016.85.85 0 0 0 0 1.194l3.459 3.483.016.015a.835.835 0 0 0 1.166-.011l9.263-9.19.016-.016a.85.85 0 0 0-.007-1.18",
    clipRule: "evenodd"
  })));
};
export default SvgRoundCheckmarkInverted;